export default {
  name: 'Carousel',
  imageTips: 'Recommended size are 1440x500(PC)，375x500(Mobile)',
  btn: {
    searchJob: 'Search Job'
  },
  placeHolder: {
    enterModuleName: 'Please enter module name',
    enterJobKeywords: 'Please enter a keyword of the job'
  },
  label: {
    moduleName: 'Module Name',
    showSearchBox: 'Search Box',
    bgImage: 'BG Image',
    imageHeight: 'Image Height',
    imageWidth: 'Image Width',
    switchInterval: 'Switch Interval',
    microsecond: 'Milliseconds (ms)'
  },
  radio: {
    show: 'Show',
    hide: 'Hide'
  }
}
